import { GENDER_TO_CATEGORY_PATH } from '../../categories/constants';
import { type SearchFilters } from '../useSearchFilters';

export function getPathFromFilters({
  groups,
  productTypes = [],
  gender,
  isKids,
}: Pick<SearchFilters, 'groups' | 'productTypes' | 'gender' | 'isKids'>) {
  const segments = [];

  if (isKids) {
    segments.push('kids');
  }
  if (gender) {
    segments.push(GENDER_TO_CATEGORY_PATH[gender]);
  }
  if (groups) {
    segments.push(groups);
  }
  if (productTypes?.length > 0) {
    segments.push(productTypes[0]);
  }

  return segments.join('/');
}
